
<ng-container *ngLet="clusterLoading$ | async as loading">


<ng-container *ngLet="geoDistrictArea$ | async">
  <div *ngLet="breakPointObserve$ | async" class="relative-container" [ngClass]="{ 'full-screen-map': isFullscreen,'disable-map':loading }" #relativeContainer>
    <div *ngLet="geoDataArea$ | async" [id]="mapElementId" class="map-container"></div>
    <div *ngIf="showFilterMenu" class="top-menu-container">
      <ng-container *ngLet="clickRecommendation$ | async">
        <span [ngClass]="{ 'element-disabled': isNotPublicCatalog }">
          <mat-checkbox
            [disabled]="isNotPublicCatalog"
            *ngIf="!dynamicDataSet"
            class="recommended mr32"
            [matTooltip]="'DATA.TABLE_FILTER.RECOMMENDED' | translate"
            [(ngModel)]="isRecommendationData"
            (click)="getRecommendationClick(!isRecommendationData)"
            >{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.RECOMMENDED' | translate }}</mat-checkbox
          >
        </span>
      </ng-container>

      <div [formGroup]="form" class="container__next-me" [ngClass]="{ 'element-disabled': isNotPublicCatalog }">
        <mat-checkbox
          formControlName="isNextMeData"
          [matTooltip]="'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate"
        >
          {{ 'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate }}
        </mat-checkbox>
        <div class="input__container">
          <input
            (keydown.enter)="getNextMeData()"
            [matTooltip]="'OTHER.RADIUS' | translate"
            formControlName="radius"
            class="input__next-me"
            placeholder="2000"
            type="text"
            min="0"
          />
          <div class="buttons-wrapper">
            <button
              [matTooltip]="'DATA.TABLE_FILTER.SEARCH' | translate"
              [disabled]="!nextMeData.isNextMeData"
              class="btn-empty search-btn"
              (click)="getNextMeData()"
            >
              <svg [icon]="icons.Search" class="svg24 inactive-color search-icon" />
            </button>
          </div>
        </div>
      </div>
      <app-search-filter
        [hasBorder]="true"
        (changedFilter)="changeFilter($event)"
        [overlayPosition]="filterOverlayPosition"
        [allFields]="allColumns$ | async"
        [class.disabled]="isRecommendationDisabled"
      ></app-search-filter>
    </div>
    <app-dynamic-update-info *ngIf="showDynamicInfo" class="dynamic-info-pc"></app-dynamic-update-info>

    <div [class.impaired]="isImpaired" [class.right-control]="controlRight" class="controls" *ngIf="showZoomControl">
      <div class="zoom mb12">
        <button
          *ngIf="this.map && this.map.getZoom()"
          [disabled]="this.map.getZoom() === maxMapZoom"
          class="btn-empty zoom-control"
          matTooltip="{{ 'OTHER.INCREASE' | translate }}"
          (click)="changeZoom$.next(1)"
          type="button"
        >
          <svg [icon]="icons.Plus" class="svg24 dark-gray-color" />
        </button>
        <button
          *ngIf="this.map && this.map.getZoom()"
          [disabled]="this.map.getZoom() === 9"
          class="btn-empty zoom-control"
          matTooltip="{{ 'OTHER.DECREASE' | translate }}"
          (click)="changeZoom$.next(-1)"
          type="button"
        >
          <svg [icon]="icons.Minus" class="svg24 dark-gray-color" />
        </button>
      </div>
      <button class="reset-zoom btn-empty zoom-control mb12" matTooltip="{{ 'OTHER.CENTER' | translate }}" (click)="resetZoom()" type="button">
        <svg [icon]="isImpaired ? icons.Search : icons.DefaultMapZoom" class="svg24 dark-gray-color" />
      </button>

      <button
        class="reset-zoom btn-empty zoom-control mb12"
        matTooltip="{{ 'OTHER.MY_LOCATION' | translate }}"
        (click)="setMyLocation()"
        type="button"
      >
        <svg
          [icon]="icons.MyLocation"
          [ngClass]="{ 'primary-color-60': this.showMyPosition, 'dark-gray-color': !this.showMyPosition }"
          class="svg24"
        />
      </button>

      <button
        *ngIf="map && mapRotation !== 0"
        class="reset-zoom btn-empty zoom-control rotation-map"
        matTooltip="{{ 'OTHER.CENTER' | translate }}"
        (click)="setRotationMap()"
        type="button"
      >
        <svg [icon]="icons.OrientationMap" class="svg24 dark-gray-color" />
      </button>
    </div>

    <div class="mobile-controls" *ngIf="showFullScreenButton">
      <button class="reset-zoom btn-empty zoom-control" (click)="toggleFullscreen()">
        <svg
          [icon]="!isFullscreen ? icons.FullScreen : icons.FullScreenNon"
          class="svg24 dark-gray-color"
          [matTooltip]="(!isFullscreen ? 'OTHER.FULL_SCREEN' : 'OTHER.NORMAL_SCREEN') | translate"
        ></svg>
      </button>
    </div>
    <app-dynamic-update-info *ngIf="showDynamicInfo" [isMobile]="true" class="mobile-dynamic-info"></app-dynamic-update-info>
  </div>
</ng-container>

<div *ngIf="loading" class="loader-container">
  <app-loader></app-loader>
</div>
</ng-container>
